<template>
    <v-container class="content" >
      <LoginLogo />

      <v-row no-gutters justify="center" align="center" class="text-center mb-5">
        {{$t('routes.forbidden.resourceForbidden')}}
      </v-row>

      <v-row no-gutters justify="center" align="center" class="">
        <v-btn type="button" v-on:click="goBack" class="bg-primary">
          <v-icon>mdi-arrow-left</v-icon>
          {{$t('routes.forbidden.goBack')}}
        </v-btn>
      </v-row>
    </v-container>
</template>

<script>
import LoginLogo from '../account/components/LoginLogo.vue'

export default {
  name: "ForbiddenPage",
  components: {
    LoginLogo,
  },
  methods: {
    goBack: function() {
      this.$router.go(-2);
    }
  }
}
</script>
